export function isIndexable(value: unknown): value is Record<string, unknown> {
	return typeof value === "object" && value !== null;
}

export function isKeyOf<T extends object>(
	obj: T,
	key?: PropertyKey,
): key is keyof T {
	return key !== undefined && key in obj;
}

/**
 * Checks if at least one first-level property is not undefined.
 */
export function hasAnyProperty<T extends object>(obj: Partial<T>): boolean {
	return Object.keys(obj).some((key) => obj[key as keyof T] !== undefined);
}

export type AssertTrue<T extends true> = T;

/**
 * CheckEqual<A, B> will be 'OK' if A and B are equal,
 * otherwise a type error will occur.
 */
export type CheckEqual<A, B> =
	// Check A extends B ...
	A extends B
		? // ... and B extends A.
			B extends A
			? true // They are equal
			: false
		: false;
